import { Vue, Component } from 'vue-property-decorator'
import BillingSidebar from '@/modules/billing-module/components/sidebar/billing-sidebar.vue'
import { billingStore } from '@/modules/billing-module/store/billing.store'

@Component({
    components: {
        BillingSidebar
    }
})
export default class BillingModule extends Vue {
    created(): void {
        billingStore.register()
    }
    destroyed(): void {
        billingStore.unregister()
    }
}
